/**
 * @file index.js
 * @author xingminghua
 * @desc vuex事件总线mixin
 */

// 批量设置computed属性
function mapEvents(events) {
    const res = {}
    if(events.length) {
        events.forEach((eventName) => {
            res[`e_${eventName}`] = function() {
                return this.$store.getters['EventBus/onEvent'](eventName)
            }
        })
    }
    return res
}
// 批量设置watcher
function mapWatchers(events) {
    const res = {}
    if(events.length) {
        events.forEach((eventName) => {
            res[`e_${eventName}`] = function(newval, oldval) {
                // 如果事件从无到有或改变，则消费该事件
                if(newval !== oldval && newval) {
                    // 尝试触发on_前缀命名的事件回调
                    if(this[`on_${eventName}`] && typeof this[`on_${eventName}`] === 'function') {
                        this[`on_${eventName}`](newval)
                    }
                    this.$store.commit('EventBus/consumeEvent', newval)
                }
            }
        })
    }
    return res
}
export default (events = []) => ({
    computed: {
        ...mapEvents(events)
    },
    watch: {
        ...mapWatchers(events)
    }
});
  